import ActionTypesEnum from './action_types'

export type ActionTypes = (typeof ActionTypesEnum)[keyof typeof ActionTypesEnum]

export function initialize(minWidthRatio: number): {
  type: ActionTypes
  payload: { left: number; right: number }
} {
  return {
    type: ActionTypesEnum.INITIALIZE,
    payload: {
      left: 0,
      right: minWidthRatio,
    },
  }
}

export function changeSize(
  width: number,
  height: number
): { type: ActionTypes; payload: { size: { width: number; height: number } } } {
  return {
    type: ActionTypesEnum.SIZE_CHANGE,
    payload: {
      size: {
        width,
        height,
      },
    },
  }
}

export function cancelFreeScroll(): { type: ActionTypes } {
  return {
    type: ActionTypesEnum.CANCEL_FREE_SCROLL,
  }
}

export function startFreeScroll(): { type: ActionTypes } {
  return {
    type: ActionTypesEnum.START_FREE_SCROLL,
  }
}

export function updateLeftAndRight(
  left: number,
  right: number
): { type: ActionTypes; payload: { left: number; right: number } } {
  return {
    type: ActionTypesEnum.UPDATE_LEFT_AND_RIGHT,
    payload: {
      left,
      right,
    },
  }
}

export function drillDownIntoTimelineItem(
  id: string | number,
  timelineItemType: string
): { type: ActionTypes; payload: { id: string | number; timelineItemType: string } } {
  return {
    type: ActionTypesEnum.TIMELINE_ITEM_DRILL_DOWN,
    payload: {
      id,
      timelineItemType,
    },
  }
}

export function drillOutOfTimelineItem(
  id: string | number,
  timelineItemType: string
): { type: ActionTypes; payload: { id: string | number; timelineItemType: string } } {
  return {
    type: ActionTypesEnum.TIMELINE_ITEM_DRILL_OUT,
    payload: {
      id,
      timelineItemType,
    },
  }
}
